import { Instagram, ArrowUp } from "lucide-react";
import { NAV_LINKS, SITE } from "@/lib/data";
import { useScrollTo } from "@/hooks/useLenis";
import { Logo } from "@/components/Logo";

export const Footer = () => {
  const scrollTo = useScrollTo();
  return (
    <footer className="relative overflow-hidden bg-navy text-sand-50" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-6 pb-10 pt-20 lg:px-12">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-4">
              <Logo className="h-14 w-14 ring-2 ring-sand-50/20" />
              <p className="eyebrow text-gold">{SITE.officialName}</p>
            </div>
            <p className="mt-4 font-display text-4xl leading-[1.02] sm:text-5xl lg:text-6xl">
              Masjid <em className="text-gold">Pantai</em> Bali
            </p>
            <p className="mt-6 max-w-md text-sm text-sand-50/60">
              Dikelola {SITE.foundation}. Masjid rahmatan lil 'alamin di pesisir barat Pulau Dewata—ruang ibadah, edukasi, dan
              pemberdayaan umat.
            </p>
          </div>
          <div className="lg:col-span-3">
            <p className="eyebrow text-sand-50/50">Jelajah</p>
            <ul className="mt-4 space-y-2">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button onClick={() => scrollTo(l.href)} className="text-sm text-sand-50/80 transition-colors hover:text-gold" data-testid={`footer-link-${l.href.slice(1)}`}>
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-3">
            <p className="eyebrow text-sand-50/50">Alamat</p>
            <p className="mt-4 text-sm text-sand-50/80">{SITE.address}</p>
            <a href={SITE.instagram} target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-2 text-sm text-sand-50/80 transition-colors hover:text-gold" data-testid="footer-instagram-link">
              <Instagram className="h-4 w-4" /> {SITE.instagramHandle}
            </a>
          </div>
        </div>
        <div className="mt-16 flex flex-wrap items-center justify-between gap-4 border-t border-sand-50/10 pt-6 text-xs text-sand-50/50">
          <div className="space-y-1">
            <p>© 2026 {SITE.name} · {SITE.foundation}</p>
            <p className="text-sand-50/35" data-testid="footer-developer-credit">
              Dikembangkan oleh{" "}
              <a
                href="mailto:didik.digital@gmail.com"
                className="underline decoration-sand-50/20 underline-offset-2 transition-colors hover:text-gold"
                data-testid="footer-developer-link"
              >
                Didik Digital
              </a>
            </p>
          </div>
          <button onClick={() => scrollTo("#beranda")} className="inline-flex items-center gap-2 transition-colors hover:text-gold" data-testid="footer-back-to-top">
            Kembali ke atas <ArrowUp className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
      <p aria-hidden="true" className="pointer-events-none select-none whitespace-nowrap px-6 pb-2 font-display text-[18vw] leading-none text-sand-50/[0.04] lg:px-12">
        Raudhatul Jannah
      </p>
    </footer>
  );
};
